import { TStats } from '@sifrovacihra/shared-ui';

export const stats2023 = {
    "cyphers": [
        {
            "Id": 1,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 2,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 3,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 4,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 5,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 6,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 7,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 8,
            "code": null,
            "name": null,
            "type": "F",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        }
    ],
    "teams": [
        {
            "Id": 25,
            "Name": "Proudoví krtci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "01:52:49",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 30,
            "Name": "JIMI",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:05:34",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 27,
            "Name": "lupi",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:15:38",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 10,
            "Name": "Kouleňové",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:22:16",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 51,
            "Name": "Sbagliato",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:24:12",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 52,
            "Name": "Podhorští mořeplavci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:25:23",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 24,
            "Name": "Jojo",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:29:08",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 40,
            "Name": "Psychokopytníci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:32:18",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 46,
            "Name": "abcde",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:39:41",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 18,
            "Name": "Formule ještě žije",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "02:55:51",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 21,
            "Name": "Pšt!",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:05:27",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 42,
            "Name": "Volyňská střela",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:17:09",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 28,
            "Name": "Vrabčáci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:17:40",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 3,
            "Name": "Škodíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:26:24",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 9,
            "Name": "KNIHMIL",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:30:50",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 39,
            "Name": "LakesCZ",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:38:12",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 38,
            "Name": "VABAnk",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:46:27",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 43,
            "Name": "Truhlíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:51:37",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 8,
            "Name": "Zcela staré kříže",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:55:33",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 16,
            "Name": "Božolé",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:57:41",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 36,
            "Name": "Trochu v tom plaveme",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:58:16",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 37,
            "Name": "Hodně v tom plaveme",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "03:58:44",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 15,
            "Name": "Nebludní Holanďané ",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:00:05",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 26,
            "Name": "Cestovka na sever",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:06:27",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 19,
            "Name": "Už tam budem",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:08:07",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 17,
            "Name": "Cuvée",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:10:16",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 13,
            "Name": "ČENDÁNO",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:19:41",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 14,
            "Name": "Výběr z hroznů",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:21:56",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 35,
            "Name": "MJ3",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:28:30",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 32,
            "Name": "Ne každý Ludvík je šílený",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:52:16",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 7,
            "Name": "náhodný kolemjdoucí",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "04:52:39",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 47,
            "Name": "Dvě grácie",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:09:01",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 12,
            "Name": "Parťačky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:17:39",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 6,
            "Name": "Fosilky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:26:03",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 45,
            "Name": "Adjuheda",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:27:49",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 31,
            "Name": "Dynamické duo",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:29:39",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 11,
            "Name": "Kraus-off-ky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:30:51",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 23,
            "Name": "Mazané housky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:35:05",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 2,
            "Name": "Monokultura",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "05:56:55",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 20,
            "Name": "A je to!",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "06:07:40",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 34,
            "Name": "Záleží na počasí",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "06:23:53",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 49,
            "Name": "Enigma103",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "06:46:02",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 29,
            "Name": "Pidlikvíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 8,
                "message": null,
                "Status": 2,
                "totalTime": "06:54:00",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 4,
            "Name": "#DEKA",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 7,
                "message": null,
                "Status": 2,
                "totalTime": "04:53:06",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 44,
            "Name": "Horizon6",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 6,
                "message": null,
                "Status": 2,
                "totalTime": "04:46:12",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 48,
            "Name": "Puštíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 6,
                "message": null,
                "Status": 2,
                "totalTime": "05:25:44",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 5,
            "Name": "Ňufíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 3,
                "message": null,
                "Status": 2,
                "totalTime": "01:40:37",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 41,
            "Name": "Doli",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 3,
                "message": null,
                "Status": 2,
                "totalTime": "01:54:18",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 50,
            "Name": "Govena",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 3,
                "message": null,
                "Status": 2,
                "totalTime": "01:56:42",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 1,
            "Name": "Knihovna",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 0,
                "message": null,
                "Status": 2,
                "totalTime": "00:00:00",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 33,
            "Name": "SLZY",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 0,
                "message": null,
                "Status": 2,
                "totalTime": "00:00:00",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        }
    ],
    "teamCyphers": [
        {
            "id_team": 28,
            "id_cypher": 1,
            "time": "2023-05-13T08:59:55",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 1,
            "time": "2023-05-13T08:59:57",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 1,
            "time": "2023-05-13T08:59:58",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 1,
            "time": "2023-05-13T08:59:59",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 1,
            "time": "2023-05-13T08:59:59",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:00",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:01",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:01",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:02",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:03",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:03",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:07",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:07",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:10",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:12",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 1,
            "time": "2023-05-13T09:01:59",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 1,
            "time": "2023-05-13T09:02:16",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 1,
            "time": "2023-05-13T09:03:15",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 1,
            "time": "2023-05-13T09:08:30",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 1,
            "time": "2023-05-13T09:09:55",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 1,
            "time": "2023-05-13T09:12:02",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 1,
            "time": "2023-05-13T09:12:51",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 1,
            "time": "2023-05-13T09:14:50",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 1,
            "time": "2023-05-13T09:15:24",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 1,
            "time": "2023-05-13T09:15:25",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 2,
            "time": "2023-05-13T09:31:45",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 2,
            "time": "2023-05-13T09:32:16",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 2,
            "time": "2023-05-13T09:36:18",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 1,
            "time": "2023-05-13T09:38:14",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 2,
            "time": "2023-05-13T09:39:13",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 2,
            "time": "2023-05-13T09:39:21",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 2,
            "time": "2023-05-13T09:39:33",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 2,
            "time": "2023-05-13T09:39:56",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 2,
            "time": "2023-05-13T09:40:09",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 2,
            "time": "2023-05-13T09:40:54",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 2,
            "time": "2023-05-13T09:41:55",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:02",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:05",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:18",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:19",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:24",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 2,
            "time": "2023-05-13T09:43:09",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 2,
            "time": "2023-05-13T09:43:17",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 2,
            "time": "2023-05-13T09:43:21",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 2,
            "time": "2023-05-13T09:43:29",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 2,
            "time": "2023-05-13T09:43:54",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 2,
            "time": "2023-05-13T09:44:27",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 2,
            "time": "2023-05-13T09:44:38",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 2,
            "time": "2023-05-13T09:44:50",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 2,
            "time": "2023-05-13T09:45:14",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 3,
            "time": "2023-05-13T09:45:15",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 2,
            "time": "2023-05-13T09:45:35",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 2,
            "time": "2023-05-13T09:45:41",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 2,
            "time": "2023-05-13T09:45:44",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 1,
            "time": "2023-05-13T09:45:50",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 3,
            "time": "2023-05-13T09:45:51",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 2,
            "time": "2023-05-13T09:46:18",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 2,
            "time": "2023-05-13T09:46:22",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 2,
            "time": "2023-05-13T09:46:53",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 2,
            "time": "2023-05-13T09:46:53",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 2,
            "time": "2023-05-13T09:46:56",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 2,
            "time": "2023-05-13T09:47:03",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 2,
            "time": "2023-05-13T09:47:10",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 2,
            "time": "2023-05-13T09:47:16",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 2,
            "time": "2023-05-13T09:47:45",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 2,
            "time": "2023-05-13T09:47:53",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 3,
            "time": "2023-05-13T09:48:32",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 2,
            "time": "2023-05-13T09:48:34",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 3,
            "time": "2023-05-13T09:48:41",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 2,
            "time": "2023-05-13T09:50:25",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 2,
            "time": "2023-05-13T09:51:28",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 3,
            "time": "2023-05-13T09:55:41",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 3,
            "time": "2023-05-13T09:56:41",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 2,
            "time": "2023-05-13T09:56:47",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 3,
            "time": "2023-05-13T09:56:48",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 3,
            "time": "2023-05-13T09:57:38",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 3,
            "time": "2023-05-13T09:58:04",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 2,
            "time": "2023-05-13T09:58:07",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 3,
            "time": "2023-05-13T09:58:40",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 4,
            "time": "2023-05-13T09:59:00",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 4,
            "time": "2023-05-13T09:59:23",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 3,
            "time": "2023-05-13T09:59:39",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 3,
            "time": "2023-05-13T09:59:53",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 3,
            "time": "2023-05-13T10:01:34",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 4,
            "time": "2023-05-13T10:01:36",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 3,
            "time": "2023-05-13T10:01:46",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 3,
            "time": "2023-05-13T10:01:57",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 3,
            "time": "2023-05-13T10:02:45",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 2,
            "time": "2023-05-13T10:04:19",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 3,
            "time": "2023-05-13T10:04:31",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 3,
            "time": "2023-05-13T10:04:56",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 3,
            "time": "2023-05-13T10:06:15",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 3,
            "time": "2023-05-13T10:06:32",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 3,
            "time": "2023-05-13T10:06:56",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 3,
            "time": "2023-05-13T10:08:10",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 3,
            "time": "2023-05-13T10:08:19",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 3,
            "time": "2023-05-13T10:08:44",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 3,
            "time": "2023-05-13T10:09:29",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 3,
            "time": "2023-05-13T10:09:47",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 3,
            "time": "2023-05-13T10:09:51",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 3,
            "time": "2023-05-13T10:10:37",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 2,
            "time": "2023-05-13T10:11:03",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 3,
            "time": "2023-05-13T10:11:09",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 3,
            "time": "2023-05-13T10:11:20",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 3,
            "time": "2023-05-13T10:12:37",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 3,
            "time": "2023-05-13T10:12:45",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 4,
            "time": "2023-05-13T10:13:18",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 3,
            "time": "2023-05-13T10:13:28",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 4,
            "time": "2023-05-13T10:13:35",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 4,
            "time": "2023-05-13T10:14:02",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 4,
            "time": "2023-05-13T10:14:04",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 3,
            "time": "2023-05-13T10:15:04",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 3,
            "time": "2023-05-13T10:16:18",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 4,
            "time": "2023-05-13T10:16:29",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 4,
            "time": "2023-05-13T10:16:34",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 3,
            "time": "2023-05-13T10:16:35",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 3,
            "time": "2023-05-13T10:17:30",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 3,
            "time": "2023-05-13T10:18:17",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 3,
            "time": "2023-05-13T10:18:30",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 3,
            "time": "2023-05-13T10:19:02",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 4,
            "time": "2023-05-13T10:19:36",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 4,
            "time": "2023-05-13T10:20:01",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 4,
            "time": "2023-05-13T10:20:17",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 4,
            "time": "2023-05-13T10:21:39",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 5,
            "time": "2023-05-13T10:22:20",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 4,
            "time": "2023-05-13T10:22:36",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 5,
            "time": "2023-05-13T10:23:26",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 5,
            "time": "2023-05-13T10:23:41",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 3,
            "time": "2023-05-13T10:24:03",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 2,
            "time": "2023-05-13T10:24:04",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 3,
            "time": "2023-05-13T10:24:07",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 3,
            "time": "2023-05-13T10:24:12",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 3,
            "time": "2023-05-13T10:24:18",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 4,
            "time": "2023-05-13T10:24:36",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 3,
            "time": "2023-05-13T10:24:36",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 3,
            "time": "2023-05-13T10:26:28",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 3,
            "time": "2023-05-13T10:26:42",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 4,
            "time": "2023-05-13T10:29:02",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 6,
            "time": "2023-05-13T10:31:24",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 4,
            "time": "2023-05-13T10:33:32",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 4,
            "time": "2023-05-13T10:35:13",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 4,
            "time": "2023-05-13T10:35:29",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 4,
            "time": "2023-05-13T10:35:47",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 5,
            "time": "2023-05-13T10:35:55",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 6,
            "time": "2023-05-13T10:38:01",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 3,
            "time": "2023-05-13T10:38:02",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 4,
            "time": "2023-05-13T10:39:13",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 5,
            "time": "2023-05-13T10:39:38",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 5,
            "time": "2023-05-13T10:43:51",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 4,
            "time": "2023-05-13T10:44:27",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 4,
            "time": "2023-05-13T10:47:32",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 6,
            "time": "2023-05-13T10:48:13",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 4,
            "time": "2023-05-13T10:48:39",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 6,
            "time": "2023-05-13T10:49:03",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 6,
            "time": "2023-05-13T10:55:09",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 4,
            "time": "2023-05-13T10:55:47",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 5,
            "time": "2023-05-13T10:57:46",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 4,
            "time": "2023-05-13T11:01:06",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 6,
            "time": "2023-05-13T11:01:17",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 4,
            "time": "2023-05-13T11:01:51",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 7,
            "time": "2023-05-13T11:03:20",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 7,
            "time": "2023-05-13T11:10:29",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 7,
            "time": "2023-05-13T11:10:47",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 6,
            "time": "2023-05-13T11:10:56",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 5,
            "time": "2023-05-13T11:11:16",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 5,
            "time": "2023-05-13T11:12:50",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 8,
            "time": "2023-05-13T11:15:38",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 8,
            "time": "2023-05-13T11:25:23",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 5,
            "time": "2023-05-13T11:26:00",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 5,
            "time": "2023-05-13T11:27:20",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 5,
            "time": "2023-05-13T11:27:39",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 6,
            "time": "2023-05-13T11:31:48",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 6,
            "time": "2023-05-13T11:31:55",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 8,
            "time": "2023-05-13T11:32:18",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 5,
            "time": "2023-05-13T11:32:19",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 5,
            "time": "2023-05-13T11:33:04",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 5,
            "time": "2023-05-13T11:33:27",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 5,
            "time": "2023-05-13T11:33:35",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 7,
            "time": "2023-05-13T11:36:56",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 5,
            "time": "2023-05-13T11:43:44",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 5,
            "time": "2023-05-13T11:43:53",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 6,
            "time": "2023-05-13T11:46:12",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 6,
            "time": "2023-05-13T11:46:57",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 5,
            "time": "2023-05-13T11:47:21",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 5,
            "time": "2023-05-13T11:48:21",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 7,
            "time": "2023-05-13T11:49:02",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 7,
            "time": "2023-05-13T11:52:49",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 7,
            "time": "2023-05-13T11:54:30",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 6,
            "time": "2023-05-13T11:58:48",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 6,
            "time": "2023-05-13T11:58:58",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 7,
            "time": "2023-05-13T11:59:26",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 8,
            "time": "2023-05-13T12:00:50",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 7,
            "time": "2023-05-13T12:00:55",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 7,
            "time": "2023-05-13T12:01:41",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 8,
            "time": "2023-05-13T12:02:09",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 7,
            "time": "2023-05-13T12:04:01",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 6,
            "time": "2023-05-13T12:04:48",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 6,
            "time": "2023-05-13T12:05:19",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 6,
            "time": "2023-05-13T12:05:30",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 8,
            "time": "2023-05-13T12:06:37",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 7,
            "time": "2023-05-13T12:06:39",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 7,
            "time": "2023-05-13T12:07:09",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 6,
            "time": "2023-05-13T12:07:25",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 6,
            "time": "2023-05-13T12:07:45",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 7,
            "time": "2023-05-13T12:08:06",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 6,
            "time": "2023-05-13T12:09:33",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 7,
            "time": "2023-05-13T12:09:51",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 8,
            "time": "2023-05-13T12:10:16",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 7,
            "time": "2023-05-13T12:10:56",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 8,
            "time": "2023-05-13T12:11:03",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 6,
            "time": "2023-05-13T12:11:31",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 5,
            "time": "2023-05-13T12:11:47",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 7,
            "time": "2023-05-13T12:12:03",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 8,
            "time": "2023-05-13T12:12:41",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 6,
            "time": "2023-05-13T12:13:40",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 8,
            "time": "2023-05-13T12:15:05",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 6,
            "time": "2023-05-13T12:16:00",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 6,
            "time": "2023-05-13T12:16:53",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 8,
            "time": "2023-05-13T12:17:40",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 7,
            "time": "2023-05-13T12:18:09",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 6,
            "time": "2023-05-13T12:19:16",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 6,
            "time": "2023-05-13T12:19:17",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 8,
            "time": "2023-05-13T12:19:41",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 7,
            "time": "2023-05-13T12:19:59",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 6,
            "time": "2023-05-13T12:21:25",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 7,
            "time": "2023-05-13T12:21:38",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 7,
            "time": "2023-05-13T12:22:09",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 7,
            "time": "2023-05-13T12:23:01",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 8,
            "time": "2023-05-13T12:23:12",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 8,
            "time": "2023-05-13T12:24:01",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 8,
            "time": "2023-05-13T12:25:33",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 6,
            "time": "2023-05-13T12:25:44",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 8,
            "time": "2023-05-13T12:26:24",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 7,
            "time": "2023-05-13T12:28:07",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 7,
            "time": "2023-05-13T12:28:33",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 7,
            "time": "2023-05-13T12:29:09",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 7,
            "time": "2023-05-13T12:29:14",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 7,
            "time": "2023-05-13T12:29:41",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 7,
            "time": "2023-05-13T12:30:43",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 8,
            "time": "2023-05-13T12:31:27",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 6,
            "time": "2023-05-13T12:35:41",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 8,
            "time": "2023-05-13T12:36:27",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 7,
            "time": "2023-05-13T12:36:37",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 8,
            "time": "2023-05-13T12:37:39",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 8,
            "time": "2023-05-13T12:37:40",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 8,
            "time": "2023-05-13T12:38:07",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 7,
            "time": "2023-05-13T12:38:41",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 7,
            "time": "2023-05-13T12:39:15",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 7,
            "time": "2023-05-13T12:40:28",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 7,
            "time": "2023-05-13T12:41:09",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 8,
            "time": "2023-05-13T12:42:49",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 8,
            "time": "2023-05-13T12:43:16",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 8,
            "time": "2023-05-13T12:43:30",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 8,
            "time": "2023-05-13T12:43:44",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 8,
            "time": "2023-05-13T12:47:39",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 7,
            "time": "2023-05-13T12:48:37",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 8,
            "time": "2023-05-13T12:51:56",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 8,
            "time": "2023-05-13T12:52:16",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 7,
            "time": "2023-05-13T12:53:16",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 8,
            "time": "2023-05-13T12:53:53",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 8,
            "time": "2023-05-13T12:56:55",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 8,
            "time": "2023-05-13T12:59:39",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 8,
            "time": "2023-05-13T13:01:02",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 7,
            "time": "2023-05-13T13:07:09",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 8,
            "time": "2023-05-13T13:09:00",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 8,
            "time": "2023-05-13T13:15:51",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 8,
            "time": "2023-05-13T13:35:05",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:14",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:16",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:18",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:18",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:21",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:21",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:22",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:22",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:23",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:26",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:27",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:27",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:29",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:29",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:30",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:35",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:40",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:52",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:52",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 1,
            "time": "2023-05-13T09:00:54",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 1,
            "time": "2023-05-13T09:14:09",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 1,
            "time": "2023-05-13T09:16:21",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 2,
            "time": "2023-05-13T09:30:16",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 2,
            "time": "2023-05-13T09:31:03",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:45",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 2,
            "time": "2023-05-13T09:42:54",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 4,
            "time": "2023-05-13T10:36:07",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 4,
            "time": "2023-05-13T10:36:27",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 4,
            "time": "2023-05-13T10:36:33",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 4,
            "time": "2023-05-13T10:41:02",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 7,
            "time": "2023-05-13T10:41:04",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 4,
            "time": "2023-05-13T10:41:25",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 4,
            "time": "2023-05-13T10:41:27",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 4,
            "time": "2023-05-13T10:41:41",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 4,
            "time": "2023-05-13T10:41:41",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 4,
            "time": "2023-05-13T10:41:56",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 4,
            "time": "2023-05-13T10:42:02",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 4,
            "time": "2023-05-13T10:42:54",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 4,
            "time": "2023-05-13T10:42:55",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 4,
            "time": "2023-05-13T10:49:26",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 5,
            "time": "2023-05-13T10:50:18",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 7,
            "time": "2023-05-13T10:50:22",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 5,
            "time": "2023-05-13T10:50:34",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 4,
            "time": "2023-05-13T10:52:45",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 8,
            "time": "2023-05-13T10:52:49",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 6,
            "time": "2023-05-13T10:53:04",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 4,
            "time": "2023-05-13T10:53:07",
            "minusPoints": 0
        },
        {
            "id_team": 14,
            "id_cypher": 4,
            "time": "2023-05-13T10:53:14",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 4,
            "time": "2023-05-13T10:53:27",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 5,
            "time": "2023-05-13T10:55:03",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 3,
            "time": "2023-05-13T10:58:11",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 5,
            "time": "2023-05-13T10:58:16",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 6,
            "time": "2023-05-13T11:00:58",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 7,
            "time": "2023-05-13T11:04:06",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 5,
            "time": "2023-05-13T11:04:38",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 4,
            "time": "2023-05-13T11:05:23",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 5,
            "time": "2023-05-13T11:05:31",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 8,
            "time": "2023-05-13T11:05:34",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 5,
            "time": "2023-05-13T11:06:18",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 5,
            "time": "2023-05-13T11:06:35",
            "minusPoints": 0
        },
        {
            "id_team": 44,
            "id_cypher": 5,
            "time": "2023-05-13T11:06:57",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 5,
            "time": "2023-05-13T11:08:16",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 7,
            "time": "2023-05-13T11:14:40",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 7,
            "time": "2023-05-13T11:14:51",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 6,
            "time": "2023-05-13T11:17:06",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 5,
            "time": "2023-05-13T11:18:21",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 5,
            "time": "2023-05-13T11:18:25",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 8,
            "time": "2023-05-13T11:22:16",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 5,
            "time": "2023-05-13T11:22:38",
            "minusPoints": 0
        },
        {
            "id_team": 12,
            "id_cypher": 5,
            "time": "2023-05-13T11:23:17",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 6,
            "time": "2023-05-13T11:23:27",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 5,
            "time": "2023-05-13T11:23:32",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 7,
            "time": "2023-05-13T11:23:50",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 8,
            "time": "2023-05-13T11:24:12",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 6,
            "time": "2023-05-13T11:24:58",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 6,
            "time": "2023-05-13T11:28:37",
            "minusPoints": 0
        },
        {
            "id_team": 48,
            "id_cypher": 5,
            "time": "2023-05-13T11:28:55",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 8,
            "time": "2023-05-13T11:29:08",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 4,
            "time": "2023-05-13T11:29:23",
            "minusPoints": 0
        },
        {
            "id_team": 43,
            "id_cypher": 6,
            "time": "2023-05-13T11:30:45",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 5,
            "time": "2023-05-13T11:30:57",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 5,
            "time": "2023-05-13T11:34:44",
            "minusPoints": 0
        },
        {
            "id_team": 45,
            "id_cypher": 5,
            "time": "2023-05-13T11:37:14",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 5,
            "time": "2023-05-13T11:37:35",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 5,
            "time": "2023-05-13T11:38:34",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 6,
            "time": "2023-05-13T11:38:39",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 7,
            "time": "2023-05-13T11:38:43",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 5,
            "time": "2023-05-13T11:39:08",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 6,
            "time": "2023-05-13T11:39:12",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 5,
            "time": "2023-05-13T11:39:15",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 6,
            "time": "2023-05-13T11:39:18",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 5,
            "time": "2023-05-13T11:39:40",
            "minusPoints": 0
        },
        {
            "id_team": 46,
            "id_cypher": 8,
            "time": "2023-05-13T11:39:41",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 5,
            "time": "2023-05-13T11:40:37",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 6,
            "time": "2023-05-13T11:44:50",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 7,
            "time": "2023-05-13T11:49:48",
            "minusPoints": 0
        },
        {
            "id_team": 47,
            "id_cypher": 6,
            "time": "2023-05-13T11:50:23",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 8,
            "time": "2023-05-13T11:50:27",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 6,
            "time": "2023-05-13T11:50:48",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 6,
            "time": "2023-05-13T11:55:15",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 8,
            "time": "2023-05-13T11:55:51",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 6,
            "time": "2023-05-13T11:56:44",
            "minusPoints": 0
        },
        {
            "id_team": 8,
            "id_cypher": 6,
            "time": "2023-05-13T11:56:49",
            "minusPoints": 0
        },
        {
            "id_team": 3,
            "id_cypher": 6,
            "time": "2023-05-13T11:57:50",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 6,
            "time": "2023-05-13T11:58:02",
            "minusPoints": 0
        }
    ],
    "teamHelps": [
        {
            "id_team": 49,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:43:39"
            }
        },
        {
            "id_team": 8,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:44:04"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:48:34"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:49:03"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:50:10"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:50:24"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:50:48"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:51:56"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:52:10"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:52:27"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:52:32"
            }
        },
        {
            "id_team": 43,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:53:07"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:53:13"
            }
        },
        {
            "id_team": 41,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:54:13"
            }
        },
        {
            "id_team": 50,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:57:35"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:57:39"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:57:19"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:58:59"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:00:55"
            }
        },
        {
            "id_team": 35,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:01:26"
            }
        },
        {
            "id_team": 5,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:01:32"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:03:19"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:08:00"
            }
        },
        {
            "id_team": 7,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:08:33"
            }
        },
        {
            "id_team": 23,
            "help": {
                "Id": 1,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:29:56"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:27:26"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:09:56"
            }
        },
        {
            "id_team": 50,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:11:03"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:13:36"
            }
        },
        {
            "id_team": 41,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:13:55"
            }
        },
        {
            "id_team": 7,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:15:25"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:19:00"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:04:08"
            }
        },
        {
            "id_team": 35,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:05:02"
            }
        },
        {
            "id_team": 5,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:02:08"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:02:38"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:00:17"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:00:43"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:57:29"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:58:41"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:58:48"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:55:27"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:56:00"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:57:03"
            }
        },
        {
            "id_team": 8,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:51:07"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 2,
                "cypher": 2,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T09:51:49"
            }
        },
        {
            "id_team": 16,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:07:52"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:19:13"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:21:02"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:18:20"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:21:16"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:15:55"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:28:11"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:31:14"
            }
        },
        {
            "id_team": 5,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:23:01"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:24:10"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:22:51"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:26:32"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:34:39"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:33:13"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:33:54"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:46:41"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:48:14"
            }
        },
        {
            "id_team": 50,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:26:48"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:36:25"
            }
        },
        {
            "id_team": 41,
            "help": {
                "Id": 3,
                "cypher": 3,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:05:45"
            }
        },
        {
            "id_team": 41,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:05:53"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:40:29"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:48:25"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:46:52"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:34:02"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:26:39"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:26:47"
            }
        },
        {
            "id_team": 13,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:23:01"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:24:34"
            }
        },
        {
            "id_team": 5,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:25:20"
            }
        },
        {
            "id_team": 16,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:26:00"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:31:20"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:28:34"
            }
        },
        {
            "id_team": 50,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:28:02"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:16:02"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:21:41"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:18:53"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 4,
                "cypher": 3,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:21:08"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:31:34"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:37:21"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:39:52"
            }
        },
        {
            "id_team": 43,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:43:31"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:48:40"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:12:44"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:15:01"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:15:04"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:56:03"
            }
        },
        {
            "id_team": 35,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:03:22"
            }
        },
        {
            "id_team": 38,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:15:53"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:16:02"
            }
        },
        {
            "id_team": 14,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:21:12"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:41:41"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:42:38"
            }
        },
        {
            "id_team": 42,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:40:17"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:50:40"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:53:09"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:53:28"
            }
        },
        {
            "id_team": 39,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:54:36"
            }
        },
        {
            "id_team": 7,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:54:54"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:59:52"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:04:12"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:06:29"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:08:10"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:08:33"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:16:21"
            }
        },
        {
            "id_team": 26,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:17:59"
            }
        },
        {
            "id_team": 23,
            "help": {
                "Id": 5,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:57:53"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:17:32"
            }
        },
        {
            "id_team": 19,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:18:54"
            }
        },
        {
            "id_team": 26,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:23:50"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:14:27"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:05:36"
            }
        },
        {
            "id_team": 12,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:01:03"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:58:07"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:59:43"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:43:01"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:21:45"
            }
        },
        {
            "id_team": 14,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:26:08"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:03:56"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:20:00"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:48:48"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 6,
                "cypher": 4,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T10:45:25"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:15:50"
            }
        },
        {
            "id_team": 7,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:43:09"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:59:57"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:00:06"
            }
        },
        {
            "id_team": 43,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:19:38"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:06:26"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:10:09"
            }
        },
        {
            "id_team": 23,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:25:37"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:14:30"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:16:55"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:44:46"
            }
        },
        {
            "id_team": 16,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:28:48"
            }
        },
        {
            "id_team": 47,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:29:45"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:37:45"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:41:09"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:49:46"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:51:28"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 7,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:57:03"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 8,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:45:05"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 8,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:07:07"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 8,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:07:25"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 8,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:31:27"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 8,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:00:33"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 8,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:46:55"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:48:27"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:00:35"
            }
        },
        {
            "id_team": 9,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:33:34"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:36:51"
            }
        },
        {
            "id_team": 36,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:08:42"
            }
        },
        {
            "id_team": 45,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:09:18"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:12:15"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:19:50"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:21:54"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:22:01"
            }
        },
        {
            "id_team": 48,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:25:48"
            }
        },
        {
            "id_team": 11,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:34:19"
            }
        },
        {
            "id_team": 23,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:42:31"
            }
        },
        {
            "id_team": 7,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:05:48"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:22:37"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 9,
                "cypher": 6,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:51:14"
            }
        },
        {
            "id_team": 44,
            "help": {
                "Id": 10,
                "cypher": 6,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:51:02"
            }
        },
        {
            "id_team": 6,
            "help": {
                "Id": 10,
                "cypher": 6,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T11:41:50"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 10,
                "cypher": 6,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:27:56"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 10,
                "cypher": 6,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:30:44"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 10,
                "cypher": 6,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:22:23"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 10,
                "cypher": 6,
                "order": 2,
                "points": 15,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:04:08"
            }
        },
        {
            "id_team": 49,
            "help": {
                "Id": 11,
                "cypher": 7,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:44:40"
            }
        },
        {
            "id_team": 29,
            "help": {
                "Id": 11,
                "cypher": 7,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:52:13"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 11,
                "cypher": 7,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2023-05-13T12:55:27"
            }
        }
    ]
} as TStats
